import { Announced } from '@fluentui/react';
import { useSearchListOrderAnnouncedText } from './useSearchListOrderAnnouncedText';
import { SearchListData } from '../SearchListContext';

/**
 * Announcement component that announces the current sort order of the list.
 */
export const OrderByAnnounced = ({
  allColumnList,
  orderBy,
}: IOrderByAnnouncedProps) => {
  const announcedMessage = useSearchListOrderAnnouncedText({
    allColumnList,
    orderBy,
  });

  if (announcedMessage) {
    return <Announced message={announcedMessage} />;
  }
  return null;
};

export interface IOrderByAnnouncedProps
  extends Pick<SearchListData, 'allColumnList' | 'orderBy'> {}
